import { render, staticRenderFns } from "./OrderGeneralInfo.vue?vue&type=template&id=bdbec88a&scoped=true"
import script from "./OrderGeneralInfo.vue?vue&type=script&lang=ts"
export * from "./OrderGeneralInfo.vue?vue&type=script&lang=ts"
import style0 from "./OrderGeneralInfo.vue?vue&type=style&index=0&id=bdbec88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbec88a",
  null
  
)

export default component.exports